import {
  DEFAULT_OG_CARD_CONFIG,
  DEFAULT_SHARE_FORMAT
} from "./chunk-ITIRBWGP.mjs";
import {
  CATEGORY_COLORS,
  CATEGORY_LABELS,
  SHARE_FORMAT_DIMENSIONS
} from "./chunk-V7UCD2TT.mjs";
import "./chunk-XGB3TDIC.mjs";
export {
  CATEGORY_COLORS,
  CATEGORY_LABELS,
  DEFAULT_OG_CARD_CONFIG,
  DEFAULT_SHARE_FORMAT,
  SHARE_FORMAT_DIMENSIONS
};
